import { render, staticRenderFns } from "./CatalogSection.vue?vue&type=template&id=0b23ce83&scoped=true&"
import script from "./CatalogSection.vue?vue&type=script&lang=js&"
export * from "./CatalogSection.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSection.vue?vue&type=style&index=0&id=0b23ce83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23ce83",
  null
  
)

export default component.exports